<lx-loading-spinner i18n-message message="Sending your request..." [loading]="true" shadingColor="rgba(0,0,0,0.5)"></lx-loading-spinner>
